import type { SwappedFormOfPayment } from '@funkit/api-base'
import { getSwappedIcon, isSavedFormOfPaymentType } from '@funkit/connect-core'

import { useFunkitColorScheme } from '../theme/FunkitThemeProvider'
import { FALLBACK_ASSET_LOGO } from './assetLogos'
import { FunIcon } from './FunIcon'
import {
  JcbIcon,
  MastercardIcon,
  UnionPayIcon,
  VisaIcon,
} from './PaymentBrandIcons'

// RN can't render the CDN card-brand logos (embedded-raster SVGs), so use local
// vectors where we have them and fall back to this generic glyph otherwise.
const CARD_ICON = 'https://sdk-cdn.fun.xyz/images/swapped/card-payment.svg'

// Local brand vectors, keyed by the normalized cardBrand (spaces→_, lowercased)
// to match SWAPPED_CARD_BRANDS. Cartes Bancaires is intentionally absent — its
// only logo is a raster inside an SVG <pattern> RN can't draw, so it falls back
// to the generic card glyph.
const BRAND_ICONS: Record<string, typeof MastercardIcon> = {
  mastercard: MastercardIcon,
  visa: VisaIcon,
  jcb: JcbIcon,
  unionpay: UnionPayIcon,
}

const genericCardIcon = (isDarkMode: boolean) =>
  isDarkMode ? CARD_ICON.replace('.svg', '-light.svg') : CARD_ICON

export function PaymentMethodIcon({ fop }: { fop: SwappedFormOfPayment }) {
  const isDarkMode = useFunkitColorScheme().colorScheme === 'dark'
  if (isSavedFormOfPaymentType(fop)) {
    const BrandIcon =
      BRAND_ICONS[fop.cardBrand.replace(/ /g, '_').toLowerCase()]
    if (BrandIcon) {
      return <BrandIcon size={32} />
    }
    return (
      <FunIcon
        uri={genericCardIcon(isDarkMode)}
        fallbackUri={FALLBACK_ASSET_LOGO}
      />
    )
  }
  return (
    <FunIcon
      uri={getSwappedIcon(fop, isDarkMode)}
      fallbackUri={FALLBACK_ASSET_LOGO}
    />
  )
}
